import React from 'react';
import ReactDOM from 'react-dom';
import { ViewerScriptWrapper } from '@wix/native-components-infra/dist/src/HOC/ViewerScriptWrapper/viewerScriptWrapper';
import { withStyles } from '@wix/native-components-infra/dist/src/HOC/withStyles/withStyles';
import { listenToHeightChanges } from 'wix-height-updater';

import viewerScript from '../viewerApp/viewerScript';
import AppRoot from '../components/App/AppRoot';

import './editor-app.st.css';

const WrappedExampleWidget = ViewerScriptWrapper(
  withStyles(AppRoot, {
    cssPath: ['editorApp.stylable.bundle.css'],
  }),
  {
    viewerScript,
    Wix: window.Wix,
    widgetConfig: {
      widgetId: '',
      getAllPublicData: true,
    },
    overrides: {
      platform: {
        baseUrls: {
          staticsBaseUrl: window.__STATICS_BASE_URL__,
        },
      },
    },
  },
);

ReactDOM.render(
  <WrappedExampleWidget />,
  document.getElementById('root'),
  () => {
    listenToHeightChanges(window.Wix, window, { minHeight: 150 });
  },
);
